import React from "react"
import FourHoop from "./Animations/four_hoop.json";
import Moon from "./Animations/moon.json";
import Organization from "./Animations/organization.json";
import Planet from "./Animations/planet.json";
import Search from "./Animations/searching.json";
import Welcome from "./Animations/welcome.json";
import BlueWelcome from "./Animations/welcome_blue.json";
import UnderConstruction from "./Animations/underConstruction.json";
import UnderConstruction1 from "./Animations/underConstruction1.json";
import UnderConstruction2 from "./Animations/underConstruction2.json";
import EmptySearchResult from "./Animations/emptySearchResult.json";
import EmptyResult from "./Animations/emptyImage.json";
import Logout from "./Animations/logout.json";

import Laptop from "./Animations/laptop.json";
import Empty from "./Animations/empty.json";
import HandBookForPublish from "./Animations/handbook.json"
import LaunchingSoon from "./Animations/launchingSoon.json";
import ComingSoon from "./Animations/comingSoon.json";

export const AnimationList = {
    FourHoop,
    Moon,
    Organization,
    Planet,
    Search,
    Welcome,
    BlueWelcome,
    UnderConstruction,
    UnderConstruction1,
    UnderConstruction2,
    EmptySearchResult,
    EmptyResult,
    Logout,
    ComingSoon,
    Laptop,
    Empty,
    HandBookForPublish,
    LaunchingSoon
}
